import Vue from 'vue'

export default () => {
  Vue.filter('titleCase', str => str.toLowerCase().replace(/\b(\w)/g, v => v.toUpperCase())),
    Vue.filter('capitalize', str => str[0].toUpperCase() + str.slice(1))
}